import { render, staticRenderFns } from "./ProjectTypeTableItem.vue?vue&type=template&id=62d54be4&"
import script from "./ProjectTypeTableItem.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports